import TextInputMask from './TextInputMask'

export default TextInputMask
